import styled, {css} from 'styled-components';

import {colors, font} from 'theme';

export const LabelContainer = styled.label`
    width: 100%;
    display: block;
`;

export const LabelText = styled.span<{
    hasError?: boolean;
    isValid?: boolean;
    isRequired: boolean;
    updatedStyle?: boolean;
}>`
    display: ${(p) => (p.isRequired ? 'flex' : 'block')};
    color: ${(p) =>
        p.hasError ? colors.danger : p.isValid ? colors.success : colors.textSecondary};
    font-style: normal;
    text-align: left;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    margin: 0 0 5px 8px;

    &:after {
        display: ${(p) => (p.isRequired ? 'block' : 'none')};
        margin-left: 3px;
        position: relative;
        content: '*';
        color: ${colors.danger};
    }

    ${(p) =>
        p.updatedStyle &&
        css`
            font-family: ${font.family.primary};
            font-weight: 600;
            font-size: 14px;
            letter-spacing: 0px;
            color: ${colors.darkGrey};

            &:after {
                color: ${colors.darkGrey};
            }
        `}
`;
